import api from './api';
import { ApiResponse, PaginatedResponse } from '../types';

export interface Atmosphere {
  _id: string;
  name: string;
  slug: string;
  status: 'active' | 'inactive';
  isDeleted: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAtmosphereData {
  name: string;
  status: 'active' | 'inactive';
}

const atmosphereService = {
  async getActiveAtmospheres(params?: {
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<PaginatedResponse<Atmosphere>>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    
    const response = await api.get(`/atmosphere/active?${queryParams.toString()}`);
    return response.data;
  },

  async createAtmosphere(atmosphereData: CreateAtmosphereData): Promise<ApiResponse<Atmosphere>> {
    const response = await api.post('/atmosphere', atmosphereData);
    return response.data;
  }
};

export default atmosphereService;
